import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as JspUtil from '../common/JspUtil';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useJspVariables, useDebugRender } from '../hooks';
import { IceIcon, PageContainer } from '../components';

const PageWsFedMessage = () => {
    useDebugRender('PageWsFedMessage');
    const location = useLocation();
    const { launcher, panelStyle } = useJspVariables();

    const [pageMessage] = useState(() => {
        return location?.state?.pageMessage || '';
    });

    const [wsFedMessage, setWsFedMessage] = useState('');

    useEffect(() => {
        if (JspUtil.isValueAvailable(window.jspSamlMessage)) {
            setWsFedMessage(window.jspSamlMessage);
        }
    }, []);

    return (
        <PageContainer id="pageWsFedMessage" dataAutomationId="page_ws_fed_message">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                <Typography fontWeight={500}>{JspUtil.getLabelFromJspVariables('title_ws_federation')}</Typography>
                {wsFedMessage && <Typography variant="body2">{wsFedMessage}</Typography>}
                {pageMessage && <Typography variant="body2">{pageMessage}</Typography>}
            </Box>
        </PageContainer>
    );
};

export default PageWsFedMessage;
